import { createFileRoute } from "@tanstack/react-router";
import ClubRedirect from "@/pages/ClubRedirect";

export const Route = createFileRoute("/$slug/register")({
  head: () => ({
    meta: [
      { title: "Aanmelden bij je club | De Hussel App" },
      { name: "description", content: "Maak een spelersaccount aan bij je tennis- of padelclub." },
      { property: "og:title", content: "Aanmelden bij je club | De Hussel App" },
      { property: "og:description", content: "Maak een spelersaccount aan bij je tennis- of padelclub." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ClubRedirect,
});
